import { render, staticRenderFns } from "./SignUpB2C.vue?vue&type=template&id=a99f5506"
import script from "./SignUpB2C.vue?vue&type=script&lang=js"
export * from "./SignUpB2C.vue?vue&type=script&lang=js"
import style0 from "./SignUpB2C.vue?vue&type=style&index=0&id=a99f5506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports